<template>
    <AdmissionsModal 
        :date-label="dateLabel"
        :event-title="eventTitle"
        :first-admission="firstAdmission" 
        :last-admission="lastAdmission" 
    />
</template>

<script>
import moment from 'moment'
import AdmissionsModal from "./components/AdmissionsModal"

export default {
    name: "App",
    components: {
        AdmissionsModal
    },
    props: {
        dateLabel: {
            type: String,
            default: '',
        },
        eventTitle: {
            type: String,
            default: '',
        },
        firstAdmission: {
            type: String,
            default: moment().format('YYYY-MM-DD'),
        },
        lastAdmission: {
            type: String,
            default: (props) => props.firstAdmission,
        },
    },
}
</script>

<style scoped>

</style>
